module.exports = "/images/vendor/flag-icon-css/flags/4x3/us.svg?ae65659236a7e348402799477237e6fa";